import React, { useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../../store/actions/system.actions'
import {
  Btn,
  ConfirmDialog,
  CustomCardColorBar,
  CustomCheckbox,
  CustomDropdown,
  CustomPanel,
  InputNumeroDecimal,
  InputNumeroInteiro,
  PageHeader,
} from '../../../../../../components'
import { tableCellCentered } from '../../../../../../assets/js/styles'
import useAnaliseResultado, { LOAD_MESSAGE } from './AnaliseResultadoHook'
import * as colors from '../../../../../../assets/js/colors'
import { Accordion, AccordionTab } from 'primereact/accordion'
import { badgeFaltaSobra } from '../ModalPosicoesAssociadas/ModalPosicoesAssociadas'
import {
  getInventarioInputLabels,
  getInventarioQuantityConfig,
  getInventarioQuantityVolumeAndUnits,
} from '../../inventario-volume-and-units.helper'

function AnaliseResultado({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useAnaliseResultado()

  const { selectedInventario } = history.location.state

  const renderQuantidadeCell = (prod, quantity) => {
    const cell = getInventarioQuantityVolumeAndUnits(prod, quantity)
    const { volumeLabel, unitsLabel } = getInventarioInputLabels(prod)
    return (
      <div style={{ display: 'inline-flex', columnGap: 12, justifyContent: 'center' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '0.72rem', color: '#14B0BF' }}>{volumeLabel}</div>
          <div style={{ fontWeight: 600 }}>{cell.volumeText}</div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '0.72rem', color: '#14B0BF' }}>{unitsLabel}</div>
          <div style={{ fontWeight: 600 }}>{cell.unitsText}</div>
        </div>
      </div>
    )
  }

  const renderQteAjusteInput = (posicao, prod) => {
    const { canUseFractionedInput } = getInventarioQuantityConfig(prod)

    if (!canUseFractionedInput) {
      return (
        <InputNumeroDecimal
          showLabel={false}
          marginTop={0}
          disabled={prod.qte_dif === 0}
          value={prod.qte_ajuste}
          onChange={value =>
            localDispatch.onChangeProduto(posicao.posicao_estoque_id, prod, 'qte_ajuste', value)
          }
        />
      )
    }

    const { volumeLabel, unitsLabel } = getInventarioInputLabels(prod)

    return (
      <div style={{ display: 'inline-flex', columnGap: 5, alignItems: 'flex-end' }}>
        <InputNumeroInteiro
          label={volumeLabel}
          marginTop={0}
          allowNegative={false}
          disabled={prod.qte_dif === 0}
          value={prod.qte_ajuste_volume}
          onChange={value =>
            localDispatch.onChangeProduto(posicao.posicao_estoque_id, prod, 'qte_ajuste_volume', value)
          }
        />
        <InputNumeroInteiro
          label={unitsLabel}
          marginTop={0}
          allowNegative={false}
          disabled={prod.qte_dif === 0}
          value={prod.qte_ajuste_frac}
          onChange={value =>
            localDispatch.onChangeProduto(posicao.posicao_estoque_id, prod, 'qte_ajuste_frac', value)
          }
        />
      </div>
    )
  }

  useEffect(() => {
    localDispatch.onInit(selectedTp, selectedInventario.inventario_id)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_POSICOES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getOperacoesEntrada(selectedTp)
        localDispatch.getOperacoesSaida(selectedTp)
        localDispatch.getPosicoesWithLastConferences(selectedTp, selectedInventario.inventario_id)
        break

      case LOAD_MESSAGE.OK_CLICK_ACERTO:
        localDispatch.onClickAcertoSave(selectedTp, state.posicoes)
        break

      case LOAD_MESSAGE.ACERTO:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.makeAcerto(selectedTp, state.body, selectedInventario.inventario_id)
        break

      case LOAD_MESSAGE.NOVA_CONFERENCIA:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.createConferenciaFromPosicao(
          selectedTp,
          selectedInventario.inventario_id,
          state.selectedPosicao.posicao_estoque_id,
        )
        break

      case LOAD_MESSAGE.LOADING:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.successMessage) {
      dispatch(showMessageBox(state.successMessage, null))
      localDispatch.resetState()
    }
  }, [state.successMessage])

  useEffect(() => {
    if (state.pathToRedirect) {
      history.push(state.pathToRedirect, { selectedInventario: state.selectedInventario })
    }
  }, [state.pathToRedirect])

  return (
    <div>
      <PageHeader>
        <span>
          8.9 - Inventario <b>{selectedInventario.inventory_name}</b> - Analise de Resultado
        </span>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={() => {}} showBtnNovo={false} onVoltar={history.goBack}>
          <React.Fragment>
            <div className="p-grid">
              <div
                className="p-col-12 "
                style={{ display: 'inline-flex', marginTop: 25, columnGap: 5, alignItems: 'start' }}
              >
                <div style={{ maxHeight: 35, marginTop: 25 }}>
                  <Btn
                    disabled={!selectedTp || state.inventarioFinished}
                    onClick={() => localDispatch.onClickAcertoOpenModal()}
                  >
                    Acerto de Estoque
                  </Btn>
                </div>
                <div style={{ maxHeight: 35, marginTop: 25 }}>
                  <Btn
                    disabled={!selectedTp || !state.inventarioFinished}
                    onClick={() =>
                      localDispatch.onClickImprimir(selectedTp, selectedInventario.inventario_id)
                    }
                  >
                    Imprimir Resultado
                  </Btn>
                </div>
                <div style={{ maxHeight: 35, marginTop: 25 }}>
                  <Btn
                    disabled={!selectedTp || state.inventarioFinished}
                    onClick={() => localDispatch.onExportarExcel(state.posicoes)}
                  >
                    Exportar
                  </Btn>
                </div>
              </div>
              <div
                className="p-col-6"
                style={{
                  display:
                    state.inventario &&
                    state.inventario._status !== 'Finalizado' &&
                    !state.inventarioFinished
                      ? 'block'
                      : 'none',
                }}
              >
                <div>
                  <CustomCardColorBar
                    value={state.totalFaltasExibicao || state.totalFaltas}
                    title={'Faltas'}
                    subTitle={`Vol / Frac.`}
                    barColor={colors.vermelho}
                  />
                  <CustomDropdown
                    label={'Operaçao Padrão de Saida'}
                    optionLabel={'name'}
                    options={state.operacoesSaida}
                    onChange={value => localDispatch.onChange('selectedDefaultOpSaida', value)}
                    value={state.selectedDefaultOpSaida}
                  />
                </div>
              </div>
              <div
                className="p-col-6"
                style={{
                  display:
                    state.inventario &&
                    state.inventario._status !== 'Finalizado' &&
                    !state.inventarioFinished
                      ? 'block'
                      : 'none',
                }}
              >
                <div>
                  <CustomCardColorBar
                    value={state.totalSobrasExibicao || state.totalSobras}
                    title={'Sobras'}
                    subTitle={`Vol / Frac.`}
                    barColor={colors.vermelho}
                  />
                  <CustomDropdown
                    label={'Operaçao Padrão de Entrada'}
                    optionLabel={'name'}
                    options={state.operacoesEntrada}
                    onChange={value => localDispatch.onChange('selectedDefaultOpEntrada', value)}
                    value={state.selectedDefaultOpEntrada}
                  />
                </div>
              </div>
              <div
                className="p-col-12 p-align-center p-justify-center"
                style={{
                  display:
                    (state.inventario && state.inventario._status === 'Finalizado') ||
                    state.inventarioFinished
                      ? 'inline-flex'
                      : 'none',
                }}
              >
                <div
                  style={{
                    marginTop: 15,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <i className="pi pi-check" style={{ fontSize: '3em' }}></i>
                  <span>Esse estoque ja foi finalizado</span>
                </div>
              </div>
              <div
                className="p-col-12"
                style={{
                  display:
                    state.inventario &&
                    state.inventario._status !== 'Finalizado' &&
                    !state.inventarioFinished
                      ? 'block'
                      : 'none',
                }}
              >
                <div className="p-grid" style={{ marginTop: 10, marginBottom: 10 }}>
                  <div className="p-col-3">
                    <CustomDropdown
                      marginTop={0}
                      disabled={!selectedTp || state.inventarioFinished}
                      label={'Ordenar por:'}
                      onChange={value => localDispatch.onChange('orderBy', value)}
                      value={state.orderBy}
                      optionLabel={'name'}
                      options={[
                        { name: 'Sequencia', option: 'sequencia' },
                        { name: 'Mais Faltas', option: 'mais_faltas' },
                        { name: 'Mais Sobras', option: 'mais_sobras' },
                      ]}
                    />
                  </div>
                  <div className="p-col-3" style={{ marginTop: 25 }}>
                    <CustomCheckbox
                      checked={state.showFaltasSobras}
                      onChange={value => localDispatch.onChange('showFaltasSobras', value)}
                    >
                      Mostrar somente faltas e sobras
                    </CustomCheckbox>
                  </div>
                </div>
                <div style={{ marginTop: 15 }}>
                  {state.posicoes.length ? (
                    <Accordion multiple={true} activeIndex={state.activeIndex}>
                      {(state.showFaltasSobras
                        ? state.posicoes.filter(p => p.total_faltas < 0 || p.total_sobras)
                        : state.posicoes
                      ).map((posicao, index) => {
                        return (
                          <AccordionTab
                            header={
                              <div
                                style={{
                                  display: 'inline-flex',
                                  columnGap: 10,
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                }}
                              >
                                <span>
                                  Sequencia: {posicao.sequencia} - Endereço: {posicao.endereco} -
                                  Status: {posicao.status}
                                </span>
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    columnGap: '5px',
                                  }}
                                >
                                  {badgeFaltaSobra(true)} - Falta
                                  {badgeFaltaSobra(false, true)} - Sobra
                                </div>
                                <Btn
                                  onClick={e => {
                                    e.preventDefault()
                                    e.stopPropagation()
                                    localDispatch.onClickOpenNovaConferenciaModal(posicao)
                                  }}
                                >
                                  Nova Conferencia
                                </Btn>
                              </div>
                            }
                            key={index}
                          >
                            <DataTable value={posicao.items}>
                              <Column
                                header="Código"
                                style={tableCellCentered()}
                                body={prod => (
                                  <span
                                    style={{
                                      display: 'inline-flex',
                                      columnGap: 5,
                                      alignItems: 'center',
                                    }}
                                  >
                                    {badgeFaltaSobra(prod.qte_dif < 0, prod.qte_dif > 0)}{' '}
                                    {prod.product_code}
                                  </span>
                                )}
                              />
                              <Column field="product_name" header="Produto" />
                              <Column field="lote" header="Lote" style={tableCellCentered(120)} />
                              <Column
                                field="data_validade"
                                header="Validade"
                                style={tableCellCentered()}
                              />
                              <Column
                                field="qte_sistema"
                                header="Qte Sistema"
                                style={tableCellCentered(110)}
                                body={prod => renderQuantidadeCell(prod, prod.qte_sistema)}
                              />
                              <Column
                                field="qte_inventory"
                                header="Qte Inventario"
                                style={tableCellCentered(110)}
                                body={prod => renderQuantidadeCell(prod, prod.qte_inventory)}
                              />
                              <Column
                                field="qte_dif"
                                header="Diferença"
                                style={tableCellCentered(110)}
                                body={prod => renderQuantidadeCell(prod, prod.qte_dif)}
                              />
                              <Column
                                field="operacao"
                                header="Operação"
                                body={prod => (
                                  <CustomDropdown
                                    disabled={prod.qte_dif === 0}
                                    value={prod.operacao}
                                    optionLabel={'name'}
                                    options={
                                      prod.qte_dif > 0
                                        ? state.operacoesEntrada
                                        : state.operacoesSaida
                                    }
                                    onChange={value =>
                                      localDispatch.onChangeProduto(
                                        posicao.posicao_estoque_id,
                                        prod,
                                        'operacao',
                                        value,
                                      )
                                    }
                                  />
                                )}
                                style={tableCellCentered(250)}
                              />
                              <Column
                                style={tableCellCentered(180)}
                                field="qte_ajuste"
                                header="Qte Ajuste"
                                body={prod => renderQteAjusteInput(posicao, prod)}
                              />
                            </DataTable>
                          </AccordionTab>
                        )
                      })}
                    </Accordion>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          </React.Fragment>
        </CustomPanel>
      </div>
      <ConfirmDialog
        title={'Atenção'}
        content={'Deseja efetuar o acerto de estoque?'}
        isVisible={state.showDialogConfirm}
        onCancelar={() => localDispatch.onClickAcertoCloseModal()}
        onOk={() => localDispatch.onClickAcerto(selectedTp, state.posicoes)}
        disabled={state.loadingMessage === LOAD_MESSAGE.OK_CLICK_ACERTO}
      />
      <ConfirmDialog
        title={'Atenção'}
        content={'Deseja realmente criar uma nova conferencia dessa posição?'}
        isVisible={state.showNovaConferenciaModal}
        onCancelar={() => localDispatch.onClickCloseNovaConferenciaModal()}
        onOk={() => localDispatch.onClickConfirmNovaConferencia(selectedTp, state.posicoes)}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(AnaliseResultado))
